import styled from 'styled-components';

import logo from '~/assets/logo.png';

export const Container = styled.section`
  position: relative;
  width: 100%;
  /* padding: 0 15px 100px; */
  padding: 0 15px 280px;
  padding: 0 15px 100px;
`;

export const Inner = styled.div`
  width: 100%;
  max-width: 1680px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
  padding-bottom: 50px;
  @media (max-width: 1680px) {
    padding-left: 15px;
    padding-right: 15px;
  }
  @media (max-width: 768px) {
    flex-wrap: wrap;
  }
  .ArrowDown {
    /* margin-bottom: -30px; */
    margin-bottom: -8px;
  }  
`;

export const ColLeft = styled.div`
  flex: 0 0 50%;
  //flex: 0 0 100%;
  max-width: 670px;
  //max-width: 770px; /* incluido quando sem video*/
  max-width:90%;
  margin: 0 auto; /* incluido quando sem video*/
  padding-right: 80px; /* incluir quando tiver video*/
  //padding-left: 80px; /* incluir quando sem video*/
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  h3 {
    width: 397px;
    height: 377px;
    background: url(${logo}) center no-repeat;
    background-size: contain;    
    span {
      position: absolute;
      left: -9999px;
    }
  }
  p {
    font-size: 18px;
    color: #27357c;
    line-height: 21px;
    text-align: center;
    letter-spacing: -1px;
    b {
      color: #831d13;
      font-weight: 700;
    }
  }
  .highlight {
    color: #27357c;
    font-size: 46px;
    line-height: 39px;
    font-weight: 900;
    letter-spacing: -4px;
    text-align: center;
    text-shadow: 2px 2px white;
    padding-bottom: 45px;
  }
.highlight2 {
    color: #27357c;
    font-size: 30px;
    line-height: 39px;
    font-weight: 600;
    letter-spacing: -4px;
    text-align: center;
    text-shadow: 2px 2px #white;
    padding-bottom: 45px;
	text-align: left;
	span {
		color: red;
	}
  }
  @media (max-width: 1400px) {
    padding-right: 5%;
    h3 {
      width: 100%;
      height: auto;
      padding-bottom: 70%;      
    }
    .highlight {
      font-size: calc(100vw / 30);
      letter-spacing: -2px;
    }
  }
  @media (max-width: 768px) {
    flex: 0 0 100%;
    padding: 0 0 50px;
    h3 {
      max-width: 397px;
      margin-bottom: 30px;      
    }
    .highlight {
      font-size: 35px;
    }
  }
  @media (max-width: 600px) {
    .highlight {
      font-size: calc(100vw / 20);
      letter-spacing: -2px;
      padding-bottom: 5%;
    }
  }
  @media (max-width: 480px) {
    .highlight {
      font-size: 25px;
      padding-bottom: 5%;
    }
  }
`;

export const ColRight = styled.div`
  //display: none !important;
  flex-grow: 1;
  position: relative;
  /*padding-top: 56.25%;*/
  padding-top: 31.25%;
  max-height: 566px;
  display: flex;
  align-items: center;
  box-shadow: 20px 20px 0 0 #831d13;
  iframe {
    position: absolute;
    top: 0;
    left: 0;
    max-height: 566px;
  }
  @media (max-width: 1400px) {
    flex: 0 0 50%;
  }
  @media (max-width: 768px) {
    flex: 0 0 100%;
    padding-top: 56.25%;
  }
`;
